import { Alert, AlertDescription, AlertIcon, Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Title } from '../../../atoms/Title';

export interface ForgotPasswordSentProps {
  username: string;
  errors?: string[];
  onForgotPasswordSubmit: (evt: React.FormEvent) => void;
  onLoginClick: () => void;
}

const ForgotPasswordSent = (props: ForgotPasswordSentProps) => {
  const onLoginClick = (evt: React.MouseEvent) => {
    evt.preventDefault();
    props.onLoginClick();
  };

  const title = 'Reset password';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb="6">
        {title}
      </Heading>

      <form onSubmit={props.onForgotPasswordSubmit}>
        {props.errors && props.errors.length > 0 && (
          <Alert status="error" mb="4">
            {[props.errors]}
          </Alert>
        )}

        <Alert status="success" mb="4">
          <AlertIcon />
          <AlertDescription>
            <Text data-testid="reset-password-message-sent" data-selector="reset-password-message-sent" mb="2">
              A link to reset your password has been emailed to the address on the account:
            </Text>

            <Text data-testid="reset-password-email" data-selector="reset-password-email" mb="0">
              <b>{props.username}</b>
            </Text>
          </AlertDescription>
        </Alert>

        <Text fontSize="sm" color="muted" mb="3">
          Didn't receive the email? Remember to check your junk folder. If you haven't received it after a few minutes:{' '}
          <Button type="submit" size="sm" variant="link" isDisabled={false} data-selector="resend-reset-link">
            Resend reset password link
          </Button>
        </Text>

        <Stack spacing="3">
          <Button as="a" href="/" onClick={onLoginClick} variant="ghost" size="lg" data-selector="back-to-login">
            Return to login form
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default ForgotPasswordSent;
